<template>
   <HorizontalFoodCard
            v-for="product in menu.products"
            :key="product.id"
            :product="product"
            :baseurl="this.baseurl"
            @showImg="showFullScreenImage(product.imgurl)"/>
  <!--<TabGroup :defaultIndex="0" >
    <TabPanels>
      <TabPanel v-for="category in menu"
                :key="category.id" class="bg-gray-700">

        <div class="flex overflow-scroll">
          <SubMenuCard v-for="subMenu in menu.subMenus"
                       :key="subMenu.name" :subMenu="subMenu"/>
        </div>
      </TabPanel>
    </TabPanels>
  </TabGroup>-->
  
  <!--   Full Screen Image-->
  <transition name="fade">
    <div
        class="fixed flex w-full h-screen top-0 items-center z-20 bg-gray-300 bg-opacity-60 backdrop-filter backdrop-blur-sm"
        v-if="fullScreenImage" @click="fullScreenImage = ''">
      <img :src="fullScreenImage" @error="$event.target.src = require('@/assets/placeholder.png')">
      <!--<img :src="fullScreenImage" @error="$event.target.src = this.baseurl+'\\'+this.imgurl">-->
      
    </div>
  </transition>
</template>

<script>
import HorizontalFoodCard from "@/components/HorizontalFoodCard";
import {getSubMenu} from "@/API/API";
//import {TabGroup, TabPanel, TabPanels} from '@headlessui/vue'
//import SubMenuCard from "@/components/SubMenuCard";
//mport {Tab, TabGroup, TabList, TabPanel, TabPanels} from '@headlessui/vue'
export default {
  name: "SubMenu",

  components: {HorizontalFoodCard/*,SubMenuCard,TabGroup,TabPanels,TabPanel,TabList,Tab*/},
  async created() {
    //console.log(process.env.VUE_APP_APIDOMAIN);
    this.baseurl=process.env.VUE_APP_APIDOMAIN;
    //console.log(1234);
    //console.log(this.baseurl);
    // only call first time we create this page, otherwise we use route watcher
    //if (Object.keys(this.menu).length === 0)
    this.menu = (await getSubMenu(this.$route.params.slug,this.$route.params.id,this.$route.params.idd)).data[0]
    //console.log("723");
    //console.log(this.menu);
    //console.log(this.menu.products[0].name);
  },
  data() {
    return {
      menu: {},
      fullScreenImage: '',
      baseurl:''
      
    }
  },

  methods: {
    showFullScreenImage(img) {
      
      this.fullScreenImage = img;
      
    }
  },
  watch: {
    async '$route'() {
      this.menu = []
      // Check the param so it doesnt send request on leaving the page (route changes on leave)
      //if (this.$route.params.id)
      //   this.menu = (await getSubMenu(this.$route.params.slug,this.$route.params.id,this.$route.params.idd)).data.result
    }
  },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>